import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function HeroIntroduction() {
  const areas = ["County Durham", "Washington", "South Shields", "Stanley", "Sunderland", "Newcastle", "Gateshead", "North Shields"];
  return <section data-section-id="264316" id="hero-introduction" className="bg-background text-foreground py-24 md:py-32 px-6 flex items-center justify-center text-center relative overflow-hidden">
      <div className="container max-w-4xl mx-auto flex flex-col items-center relative z-10 animate-in fade-in slide-in-from-bottom-8 duration-1000 ease-out">
        <h1 className="text-4xl md:text-5xl lg:text-7xl font-serif font-bold mb-6 tracking-tight text-primary">Roofing & Roofline Services Across County Durham & The North East</h1>
        <p className="text-lg md:text-xl text-muted-foreground mb-8 max-w-2xl leading-relaxed font-sans">Five Star Roofline provide professional roof repairs, uPVC roofline replacements, EPDM rubber roofing, dry verge systems and more across County Durham, Sunderland, Newcastle, Gateshead and surrounding North East areas.</p>

        <ul className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12 w-full max-w-3xl">
          {areas.map((area, i) => <li key={area} data-index={i} className="text-sm md:text-base font-sans font-medium text-foreground/80 border border-primary/20 bg-card/50 py-2 px-4 rounded-md shadow-sm">
              {area}
            </li>)}
        </ul>

        <Button asChild size="lg" className="font-sans font-bold uppercase tracking-wider px-10 py-6 rounded-lg shadow-lg hover:scale-105 transition-transform">
          <Link to="/ServicesPage">Services</Link>
        </Button>
      </div>
    </section>;
}